export default __webpack_public_path__ + "static/media/edit.abb95a0d.svg";